import cart from '@ppcp/cart';
import product from '@ppcp/product';
import Actions from '@ppcp/actions';
import {
    getSetting,
    getPayPalQueryParams,
    loadPayPalSdk,
    isCheckout,
    isCart,
    isProduct,
    isShop,
    isMiniCartEnabled
} from '@ppcp/utils';
import {
    PayLaterProductMessage,
    PayLaterCartMessage,
    PayLaterCheckoutMessage,
    PayLaterMiniCartMessage,
    PayLaterShopMessage
} from '../paylater-message';

const queryParams = getPayPalQueryParams();
const actions = new Actions();


const settings = getSetting('payLaterMessage');
const {
    enabled = false,
    miniCartEnabled = false
} = settings;

const props = {actions, queryParams};

if (enabled) {
    // Initialize product page message
    if (isProduct()) {
        new PayLaterProductMessage({product, context: 'product', ...props}).initialize();
    }

    // Initialize cart page message
    if (isCart()) {
        new PayLaterCartMessage({cart, context: 'cart', ...props}).initialize();
    }

    // Initialize checkout page message (only if placeOrderEnabled)
    if (isCheckout()) {
        new PayLaterCheckoutMessage({cart, context: 'checkout', ...props}).initialize();
    }

    if (isShop()) {
        new PayLaterShopMessage({context: 'shop', data: settings, ...props}).initialize();
    }
}

// Initialize mini cart message (available on multiple pages)
if (miniCartEnabled || document.querySelector('.woocommerce-mini-cart__total')) {
    new PayLaterMiniCartMessage({cart, context: 'minicart', ...props}).initialize();
}
